
  document.addEventListener('DOMContentLoaded', function () {
    class WJBannerSlide extends HTMLElement {
      constructor() {
        super();
        this.swiperList = null;
        this.swiperThumbs = null;
        this.activeIndex = 0;
        this.slider = null;

        this.navProgressRaf = null;
        this.autoplayEnabled = true;
        // 后台填写秒，代码统一换算成毫秒
        this.autoplayDelay = 4000;
      }

      connectedCallback() {
        this.initSwiper();
      }

      disconnectedCallback() {
        if (this.navProgressRaf) {
          cancelAnimationFrame(this.navProgressRaf);
          this.navProgressRaf = null;
        }
        if (this.swiperList) {
          this.swiperList.destroy(true, true);
        }
        if (this.swiperThumbs) {
          this.swiperThumbs.destroy(true, true);
        }
      }

      initSwiper() {
        const listEl = this.querySelector('.wj-banner-slide-list.swiper');
        const thumbsEl = this.querySelector('.wj-banner-slide-thumbs.swiper');
        if (!listEl || !thumbsEl) return;

        // Check if already initialized
        if (listEl.swiper) {
          this.swiperList = listEl.swiper;
          return;
        }

        // Initialize Thumbs Swiper
        this.swiperThumbs = new Swiper(thumbsEl, {
          slidesPerView: 'auto',
          spaceBetween: 0,
          loop: false,
          centeredSlides: false,
          speed: 300,
          slideToClickedSlide: true,
        });

        // Initialize Main List Swiper
        this.swiperList = new Swiper(listEl, {
          slidesPerView: 1,
          spaceBetween: 0,
          loop: false,
          centeredSlides: false,
          speed: 500,
          grabCursor: true,
          effect: 'fade',
          fadeEffect: {
            crossFade: true,
          },
          
          pagination: {
            el: this.querySelector('.wj-banner-slide-pagination'),
            clickable: true,
          },
          thumbs: {
            swiper: this.swiperThumbs,
          },
          on: {
            init: (e) => {
              setTimeout(() => {
                e.emit('slideChangeTransitionEnd')
              }, 1000)
            },
            slideChangeTransitionEnd: (e) => {
              const containers = this.querySelectorAll('.yg-video-container');
              const currentContainer = containers[e.realIndex ?? e.activeIndex];

              containers.forEach((container) => {
                const video = container.querySelector('yg-video');
                if (video && typeof video.pauseVideo === 'function') {
                  container.classList.remove('active')
                  video.pauseVideo();
                }
              })

              if (currentContainer) {
                const video = currentContainer.querySelector('yg-video');
                if (video && typeof video.playVideo === 'function') {
                  currentContainer.classList.add('active')
                  video.playVideo();
                }
              }

              // 进度条与 autoplay 的计时从过渡结束后开始更贴合 Swiper 行为
              this.startNavProgress(e.realIndex ?? e.activeIndex);
            },
          },
        });

        // Thumbs click to slide
        const navItems = this.querySelectorAll('.wj-banner-slide-nav-item');
        navItems.forEach((item, index) => {
          item.addEventListener('click', () => {
            if (this.swiperList) {
              this.swiperList.slideTo(index);
            }
          });
        });

        // Update active state on slide change
        this.swiperList.on('slideChange', () => {
          this.updateActiveState();
        });

        // Initialize active state
        this.updateActiveState();

        // Listen for wj-color-switch event from wj-animation-card
        document.addEventListener('wj-color-switch', (e) => {
          if (e.detail && typeof e.detail.index === 'number') {
            if (this.swiperList) {
              this.swiperList.slideTo(e.detail.index);
            }
          }
        });

        // 获取滑块元素
        // this.slider = this.querySelector('.nav-slider');
        // if (this.slider) {
        //   this.updateSliderPosition(this.activeIndex);
        // }
      }

      // 更新滑块位置
      updateSliderPosition(index) {
        if (!this.slider) return;

        const navItems = this.querySelectorAll('.wj-banner-slide-nav-item');
        const targetItem = navItems[index];

        if (targetItem) {
          const itemWidth = targetItem.offsetWidth;
          const itemLeft = targetItem.offsetLeft;

          this.slider.style.width = `${itemWidth}px`;
          this.slider.style.transform = `translateX(${itemLeft}px)`;
        }
      }

      updateActiveState() {
        if (!this.swiperList) return;

        const realIndex = this.swiperList.realIndex || this.swiperList.activeIndex;
        this.activeIndex = realIndex;

        // 更新滑块位置
        // this.updateSliderPosition(realIndex);

        // Update content visibility
        const contents = this.querySelectorAll('.wj-banner-slide-content');
        contents.forEach((content, index) => {
          if (index === realIndex) {
            content.classList.add('active');
          } else {
            content.classList.remove('active');
          }
        });

        // Update thumbs active state
        const navItems = this.querySelectorAll('.wj-banner-slide-nav-item');
        navItems.forEach((item, index) => {
          if (index === realIndex) {
            item.classList.add('active');
          } else {
            item.classList.remove('active');
          }
        });

        // 进度条在 slideChangeTransitionEnd 中启动（更准确）
      }

      clearNavProgress() {
        if (this.navProgressRaf) {
          cancelAnimationFrame(this.navProgressRaf);
          this.navProgressRaf = null;
        }
        const circles = this.querySelectorAll('.yg-banner-nav-circle');
        circles.forEach((circle) => {
          circle.style.setProperty('--yg-nav-progress', 0);
        });
      }

      startNavProgress(index) {
        this.clearNavProgress();

        if (!this.autoplayEnabled) return;
        if (!this.swiperList || !this.swiperList.params || !this.swiperList.params.autoplay) return;

        const navItems = this.querySelectorAll('.wj-banner-slide-nav-item');
        const activeItem = navItems[index];
        const circle = activeItem && activeItem.querySelector('.yg-banner-nav-circle');
        if (!circle) return;

        const delay = Number(this.swiperList.params.autoplay.delay || this.autoplayDelay || 4000);
        const start = performance.now();

        const tick = (now) => {
          const p = Math.min(1, Math.max(0, (now - start) / delay));
          circle.style.setProperty('--yg-nav-progress', p.toFixed(4));
          if (p < 1) {
            this.navProgressRaf = requestAnimationFrame(tick);
          }
        };

        circle.style.setProperty('--yg-nav-progress', 0);
        this.navProgressRaf = requestAnimationFrame(tick);
      }
    }

    if (!customElements.get('wj-banner-slide')) {
      customElements.define('wj-banner-slide', WJBannerSlide);
    }
  });

